import React from 'react';

const YCodeThumbnail = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    xs: 'w-8 h-8',
    small: 'w-14 h-14',
    medium: 'w-24 h-24',
    large: 'w-32 h-32',
    xl: 'w-40 h-40'
  };

  return (
    <div className={`${sizeClasses[size]} ${className} relative group cursor-pointer`}>
      <img 
        src="/ycode-logo.png.png" 
        alt="YCODE Logo" 
        className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
      />
    </div>
  );
};

export default YCodeThumbnail;

